import { render, staticRenderFns } from "./UserGroupSearch.vue?vue&type=template&id=61d56810&scoped=true"
import script from "./UserGroupSearch.vue?vue&type=script&lang=js"
export * from "./UserGroupSearch.vue?vue&type=script&lang=js"
import style0 from "./UserGroupSearch.vue?vue&type=style&index=0&id=61d56810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d56810",
  null
  
)

export default component.exports